const isNumPattern = /^\d+$/;
export const feet = (value, previousValue) =>
  (isNumPattern.test(value) && value.length <= 1 && parseInt(value, 10) !== 0) || value === ''
    ? value
    : previousValue;

export const inches = (value, previousValue) =>
  (isNumPattern.test(value) && value.length <= 2 && parseInt(value, 10) <= 12) || value === ''
    ? value
    : previousValue;

export const cm = (value, previousValue) =>
  (isNumPattern.test(value) && value.length <= 3 && parseInt(value, 10) !== 0) || value === ''
    ? value
    : previousValue;
